"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useMarketplaceCountryEffect = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var R = _interopRequireWildcard(require("ramda"));

var _marketplace = require("../store/marketplace/marketplace.selector");

var _marketplace2 = require("../store/marketplace/marketplace.actions");

var _recipient = require("../store/recipient/recipient.selector");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sortItems = [{
  id: 1,
  name: 'Popularity',
  sort: {
    'sort[column]': 'popularity',
    'sort[order]': 'desc'
  }
}, {
  id: 2,
  name: 'Name (A-Z)',
  sort: {
    'sort[column]': 'name',
    'sort[order]': 'asc'
  }
}, {
  id: 3,
  name: 'Name (Z-A)',
  sort: {
    'sort[column]': 'name',
    'sort[order]': 'desc'
  }
}, {
  id: 4,
  name: 'New',
  sort: {
    'sort[column]': 'date',
    'sort[order]': 'desc'
  }
}];

var useMarketplaceCountryEffect = function useMarketplaceCountryEffect(countryId) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (countryId) {
      dispatch((0, _marketplace2.setMarketplaceCountryId)(countryId));
    }
  }, [countryId, dispatch]);
}; // id is a campaign or gift id


exports.useMarketplaceCountryEffect = useMarketplaceCountryEffect;

var useMarketplace = function useMarketplace(id) {
  var loadMarketplaceProducts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _marketplace2.loadExchangeProductsRequest;
  var loadMarketplaceFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _marketplace2.loadFiltersRequest;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_marketplace.getMarketplaceIsLoading);
  var pagination = (0, _reactRedux.useSelector)(_marketplace.getProductsPagination);

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showFilters = _useState4[0],
      setShowFilters = _useState4[1];

  var _useState5 = (0, _react.useState)(1),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedSortId = _useState6[0],
      setSelectedSortId = _useState6[1];

  var selectedSort = (0, _react.useMemo)(function () {
    return sortItems.find(function (sortItem) {
      return sortItem.id === selectedSortId;
    });
  }, [selectedSortId]);
  var marketplaceCountryId = (0, _reactRedux.useSelector)(_marketplace.getMarketplaceCountryId);
  var createRecipientCountryId = (0, _reactRedux.useSelector)(_recipient.getRecipientCountryId);
  var countryId = createRecipientCountryId || marketplaceCountryId;
  var filters = (0, _reactRedux.useSelector)(_marketplace.getFilters);

  var _useState7 = (0, _react.useState)({}),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      types = _useState8[0],
      setTypes = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      categories = _useState10[0],
      setCategories = _useState10[1];

  var filtersOptions = (0, _react.useMemo)(function () {
    return {
      type: R.compose(R.map(function (type) {
        return parseInt(type, 10);
      }), R.keys, R.filter(function (type) {
        return !!type;
      }))(types),
      category: R.map(function (category) {
        return category.value;
      }, categories || [])
    };
  }, [types, categories]);
  var countryIdOptions = (0, _react.useMemo)(function () {
    return countryId ? {
      country_id: countryId
    } : {};
  }, [countryId]);
  var initialLoadProduct = (0, _react.useCallback)(function () {
    dispatch((0, _marketplace2.clearProducts)());

    if (id) {
      dispatch(loadMarketplaceFilters(id));
      dispatch(loadMarketplaceProducts({
        id,
        requestOptions: _objectSpread({
          page: 1,
          per_page: pagination.per_page,
          search: '',
          'sort[column]': 'popularity',
          'sort[order]': 'desc'
        }, countryIdOptions)
      }));
    }
  }, [countryIdOptions, dispatch, id, loadMarketplaceFilters, loadMarketplaceProducts, pagination.per_page]);
  var loadProducts = (0, _react.useCallback)(function () {
    if (!isLoading) {
      dispatch(loadMarketplaceProducts({
        id,
        requestOptions: _objectSpread(_objectSpread(_objectSpread({
          page: parseInt(pagination.current_page, 10) + 1,
          per_page: pagination.per_page,
          search
        }, selectedSort.sort), filtersOptions), countryIdOptions)
      }));
    }
  }, [isLoading, dispatch, loadMarketplaceProducts, id, pagination.current_page, pagination.per_page, search, selectedSort.sort, filtersOptions, countryIdOptions]);
  var onFilterProducts = (0, _react.useCallback)(function () {
    setShowFilters(false);
    dispatch((0, _marketplace2.clearProducts)());
    dispatch(loadMarketplaceProducts({
      id,
      requestOptions: _objectSpread(_objectSpread(_objectSpread({
        page: 1,
        per_page: pagination.per_page,
        search
      }, selectedSort.sort), filtersOptions), countryIdOptions)
    }));
  }, [dispatch, loadMarketplaceProducts, id, pagination.per_page, search, selectedSort.sort, filtersOptions, countryIdOptions]);
  var onSortProducts = (0, _react.useCallback)(function (e) {
    setSelectedSortId(e.sort);
    dispatch((0, _marketplace2.clearProducts)());
    dispatch(loadMarketplaceProducts({
      id,
      requestOptions: _objectSpread(_objectSpread(_objectSpread({
        page: 1,
        search,
        per_page: pagination.per_page
      }, sortItems.find(function (sortItem) {
        return sortItem.id === e.sort;
      }).sort), filtersOptions), countryIdOptions)
    }));
  }, [dispatch, loadMarketplaceProducts, id, search, pagination.per_page, filtersOptions, countryIdOptions]);
  var onSearchProducts = (0, _react.useCallback)(function (e) {
    setSearch(e.target.value);
    dispatch((0, _marketplace2.clearProducts)());
    dispatch(loadMarketplaceProducts({
      id,
      requestOptions: _objectSpread(_objectSpread(_objectSpread({
        page: 1,
        per_page: pagination.per_page,
        search: e.target.value
      }, selectedSort.sort), filtersOptions), countryIdOptions)
    }));
  }, [dispatch, loadMarketplaceProducts, id, pagination.per_page, selectedSort.sort, filtersOptions, countryIdOptions]);
  var products = (0, _reactRedux.useSelector)(_marketplace.getProducts);
  return {
    setCategories,
    categories,
    setTypes,
    types,
    filters,
    pagination,
    showFilters,
    setShowFilters,
    search,
    setSearch,
    selectedSortId,
    sortItems,
    loadProducts,
    products,
    isLoading,
    filtersOptions,
    onFilterProducts,
    onSortProducts,
    onSearchProducts,
    initialLoadProduct
  };
};

var _default = useMarketplace;
exports.default = _default;